/*
 * @Author: Src
 * @Date: 2025-05-23 10:32:05
 * @LastEditTime: 2026-06-24 22:13:21
 * @LastEditors: Src
 * @FilePath: /work-station/src/services/invoice.service.ts
 * @Description: 头部注释配置模板
 */
import { injectable, inject } from 'inversify';
import HttpClient from './http.service';

@injectable()
export default class InvoiceService {
  @inject(HttpClient)
  protected http!: HttpClient;

  /**
   * 获取佣金订单列表
   * @param query
   * @returns
   */
  async getInvoiceCommissionOrders(query: any, loadingEl?: Element | Vue) {
    try {
      const res = await this.http.get('/invoice/commission_orders', {
        params: query,
        data: {
          loadingEl,
        },
      }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 获取抬头列表
   * @param query
   * @returns
   */
  async getInvoiceBuyerList(query: any) {
    try {
      const res = await this.http.get('/invoice/buyer_list', {
        params: query,
      }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 添加抬头
   * @param query
   * @returns
   */
  async addInvoiceBuyer(query: any) {
    try {
      const res = await this.http.post('/invoice/add_buyer', query) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 编辑抬头
   * @param id
   * @param query
   * @returns
   */
  async editInvoiceBuyer(id: string, query: any) {
    try {
      const res = await this.http.post(`/invoice/edit_buyer/${id}`, query) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }


  /**
   * 搜索品牌下门店
   * @param query
   * @returns
   */
  async searchShops(query: any) {
    try {
      const res = await this.http.get('/invoice/search_shops', { params: query }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 申请开票
   * @param query
   * @returns
   */
  async invoiceApply(query: any) {
    try {
      const res = await this.http.post('/invoice/apply', query) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }


  /**
   * 获取发票管理列表
   * @param query
   * @returns
   */
  async getInvoiceManageList(query: any) {
    try {
      const res = await this.http.get('/invoice/manage/list', { params: query }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 获取发票管理详情
   * @param id
   * @returns
   */
  async getInvoiceManageDetail(id: string) {
    try {
      const res = await this.http.get(`/invoice/manage/detail/${id}`) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }


  /**
   * 审核发票
   * @param id
   * @param query
   * @returns
   */
  async invoiceManageAudit(params: object) {
    try {
      const res = await this.http.post('/invoice/manage/audit', params) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 导出发票
   * @param query
   * @returns
   */
  async invoiceManageExport(query: any) {
    try {
      const res = await this.http.get('/invoice/manage/export', { params: query, responseType: 'arraybuffer' }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }


  /**
   * 获取发票记录
   * @param query
   * @returns
   */
  async getInvoiceRecord(query: any) {
    try {
      const res = await this.http.get('/invoice/record', { params: query }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 获取抬头详情
   * @param buyer_id
   * @returns
   */
  async getInvoiceBuyerInfo(buyer_id: string) {
    try {
      const res = await this.http.get(`/invoice/buyer_info/${buyer_id}`) as any;
      return res;
    } catch (error) {
      //  console.error(error);
      return null;
    }
  }

  /**
   * 获取发票数据列表
   * @param id
   * @returns
   */
  async getInvoiceDataList(id: string, query: any) {
    try {
      const res = await this.http.get(`/invoice/data_list/${id}`, { params: query }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 根据发票ID获取发票数据列表
   * @param id
   * @returns
   */
  async getInvoiceDataListByOrderId(order_id: string, query: any) {
    try {
      const res = await this.http.get(`/invoice/manage/data_list/${order_id}`, { params: query }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 根据发票ID导出发票数据
   * @param id
   * @param query
   * @returns
   */
  async getInvoiceDataListByOrderIdExport(id: string, query: any) {
    try {
      const res = await this.http.get(`/invoice/manage/data_list/${id}/export`, { params: query, responseType: 'arraybuffer' }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 重新上传发票
   * @param id
   * @param query
   * @returns
   */
  async invoiceReapply(query: any) {
    try {
      const res = await this.http.post('/invoice/reapply', query) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 标记已开票
   * @param id
   * @param query
   * @returns
   */
  async invoiceManageInvoiced(query: any) {
    try {
      const res = await this.http.post('/invoice/manage/invoiced', query) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }
  /**
   * 获取开票批次列表
   * @param query
   * @returns
   */
  async getInvoiceManageInvoicingBatch(query: any) {
    try {
      const res = await this.http.get('/invoice/manage/invoicing_batch', { params: query }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 开票管理驳回
   * @param query
   * @returns
   */
  async invoiceManageReject(query: any) {
    try {
      const res = await this.http.post('/invoice/manage/reject', query) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 获取开票门店
   * @param query
   * @returns
   */
  async getInvoiceCommissionOrderShops(query: any) {
    try {
      const res = await this.http.get('/invoice/commission_order_shops', { params: query }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 核销单保险列表
   * @param query
   * @returns
   */
  async getInvoiceInsuranceOrders(query: any) {
    try {
      const res = await this.http.get('invoice/insurance_bills', { params: query }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 保单筛选门店
   * @param query
   * @returns
   */
  async getInsuranceBills(query: any) {
    try {
      const res = await this.http.get('invoice/insurance_bills', { params: query }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 获取品牌下有保单店铺接口
   * @param query
   * @returns
   */
  async getInsuranceBillsShops(query: any) {
    try {
      const res = await this.http.get('invoice/insurance_bills_shops', { params: query }) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 品牌申请保单发票接口
   * @param query
   * @returns
   */
  async applyInsuranceInvoice(query: any) {
    try {
      const res = await this.http.post('invoice/apply_insurance_invoice', query) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }

  /**
   * 保单对应的核销单
   * @param policy_no
   * @returns
   */
  async getInsuranceOrder(policy_no: string) {
    try {
      const res = await this.http.get(`invoice/insurance_order/${policy_no}`) as any;
      return res;
    } catch (error) {
      // console.error(error);
      return null;
    }
  }
}
